/* Secret Scents — scripts propios (vanilla, sin librerías) */

(function () {
  'use strict';

  function textoConversion(montoPyg) {
    var config = window.ssMonedas;
    if (!config || !config.mostrar) return '';
    var tasaUsd = parseFloat(config.tasaUsd);
    var tasaArs = parseFloat(config.tasaArs);
    if (!tasaUsd || !tasaArs || !isFinite(montoPyg)) return '';

    var usd = montoPyg / tasaUsd;
    var ars = montoPyg / tasaArs;

    try {
      var fmtUsd = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(usd);
      var fmtArs = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 }).format(ars);
      return '≈ US$ ' + fmtUsd + ' · AR$ ' + fmtArs;
    } catch (err) {
      return '≈ US$ ' + Math.round(usd) + ' · AR$ ' + Math.round(ars);
    }
  }

  function initPreciosConvertidos() {
    if (!window.ssMonedas || !window.ssMonedas.mostrar) return;

    document.querySelectorAll('[data-ss-pyg]').forEach(function (el) {
      if (el.dataset.ssConvertidoListo) return;
      var pyg = parseFloat(el.getAttribute('data-ss-pyg'));
      if (!pyg) return;
      var texto = textoConversion(pyg);
      if (!texto) return;

      if (el.classList.contains('ss-precio-convertido')) {
        el.textContent = texto;
      } else {
        var linea = document.createElement('span');
        linea.className = 'ss-precio-convertido ss-precio-convertido--tarjeta';
        linea.textContent = texto;
        el.appendChild(linea);
      }
      el.dataset.ssConvertidoListo = '1';
    });
  }

  function initReveal() {
    var items = document.querySelectorAll('.ss-reveal');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('ss-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ss-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach(function (el, index) {
      var grupo = el.closest('[data-ss-stagger]');
      if (grupo) {
        var indiceGrupo = Array.prototype.indexOf.call(grupo.querySelectorAll('.ss-reveal'), el);
        el.style.setProperty('--ss-retraso', String(indiceGrupo * 90));
      }
      observer.observe(el);
    });
  }

  function initResenas() {
    document.querySelectorAll('[data-ss-resenas]').forEach(function (bloque) {
      var pista = bloque.querySelector('.ss-resenas__pista');
      var prev = bloque.querySelector('.ss-anterior');
      var next = bloque.querySelector('.ss-siguiente');
      if (!pista || !prev || !next) return;

      function paso() {
        var tarjeta = pista.querySelector('.ss-resenas__tarjeta');
        return tarjeta ? tarjeta.getBoundingClientRect().width + 32 : 320;
      }

      next.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: 'smooth' });
      });
      prev.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
    });
  }

  function initGaleriaProducto() {
    document.querySelectorAll('[data-ss-galeria]').forEach(function (galeria) {
      var principalImg = galeria.querySelector('.ss-galeria__principal img');
      var principalWrap = galeria.querySelector('.ss-galeria__principal');
      var miniaturas = galeria.querySelectorAll('.ss-galeria__miniatura');

      miniaturas.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-src');
          var srcset = mini.getAttribute('data-srcset');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src || !principalImg) return;
          principalImg.style.opacity = '0';
          window.setTimeout(function () {
            principalImg.src = src;
            if (srcset) principalImg.srcset = srcset;
            principalImg.alt = alt;
            principalImg.style.opacity = '1';
          }, 150);
          miniaturas.forEach(function (m) { m.classList.remove('ss-activa'); });
          mini.classList.add('ss-activa');
        });
      });

      if (principalWrap && window.matchMedia('(min-width: 990px)').matches) {
        principalWrap.addEventListener('mousemove', function (e) {
          var rect = principalWrap.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          if (principalImg) principalImg.style.transformOrigin = x + '% ' + y + '%';
        });
        principalWrap.addEventListener('mouseenter', function () {
          principalWrap.classList.add('ss-zoom-activo');
        });
        principalWrap.addEventListener('mouseleave', function () {
          principalWrap.classList.remove('ss-zoom-activo');
        });
      }
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-ss-formulario-producto]').forEach(function (contenedor) {
      var datosVariantes;
      try {
        datosVariantes = JSON.parse(contenedor.querySelector('[data-ss-variantes-json]').textContent);
      } catch (err) {
        return;
      }

      var pastillas = contenedor.querySelectorAll('.ss-compra__pastilla');
      var inputId = contenedor.querySelector('input[name="id"]');
      var precioEl = contenedor.querySelector('[data-ss-precio]');
      var precioCompareEl = contenedor.querySelector('[data-ss-precio-comparado]');
      var precioConvertidoEl = contenedor.closest('.ss-compra')
        ? contenedor.closest('.ss-compra').querySelector('.ss-precio-convertido')
        : null;
      var botonAgregar = contenedor.querySelector('[data-ss-agregar]');
      var disponibilidadEl = contenedor.querySelector('[data-ss-disponibilidad]');
      var puntoEl = contenedor.querySelector('.ss-compra__punto');

      var seleccion = {};
      pastillas.forEach(function (p) {
        if (p.classList.contains('ss-activa')) {
          seleccion[p.getAttribute('data-opcion')] = p.getAttribute('data-valor');
        }
      });

      function formatoMoneda(centavos) {
        var moneda = (window.themeMoneda && window.themeMoneda.currency) || 'USD';
        var locale = document.documentElement.lang || 'es';
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: moneda, currencyDisplay: 'narrowSymbol' }).format(centavos / 100);
        } catch (err) {
          return (centavos / 100).toFixed(2) + ' ' + moneda;
        }
      }

      function actualizar() {
        var variante = datosVariantes.find(function (v) {
          return v.options.every(function (val, i) {
            var nombreOpcion = contenedor.getAttribute('data-opcion-' + (i + 1));
            return seleccion[nombreOpcion] === val;
          });
        });

        if (!variante) return;

        if (inputId) inputId.value = variante.id;

        if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
        if (precioConvertidoEl) {
          var texto = textoConversion(variante.price / 100);
          if (texto) precioConvertidoEl.textContent = texto;
        }
        if (precioCompareEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioCompareEl.textContent = formatoMoneda(variante.compare_at_price);
            precioCompareEl.hidden = false;
          } else {
            precioCompareEl.hidden = true;
          }
        }

        pastillas.forEach(function (p) {
          var opcion = p.getAttribute('data-opcion');
          var valor = p.getAttribute('data-valor');
          var existeCombinacion = datosVariantes.some(function (v) {
            return v.available && v.options[Object.keys(seleccion).indexOf(opcion)] === valor;
          });
          p.disabled = !existeCombinacion;
        });

        if (botonAgregar) {
          botonAgregar.disabled = !variante.available;
          botonAgregar.textContent = variante.available
            ? botonAgregar.getAttribute('data-texto-disponible')
            : botonAgregar.getAttribute('data-texto-agotado');
        }
        if (disponibilidadEl) {
          disponibilidadEl.textContent = variante.available
            ? disponibilidadEl.getAttribute('data-texto-disponible')
            : disponibilidadEl.getAttribute('data-texto-agotado');
        }
        if (puntoEl) puntoEl.classList.toggle('ss-compra__punto--agotado', !variante.available);
      }

      pastillas.forEach(function (p) {
        p.addEventListener('click', function () {
          var opcion = p.getAttribute('data-opcion');
          contenedor.querySelectorAll('.ss-compra__pastilla[data-opcion="' + CSS.escape(opcion) + '"]').forEach(function (el) {
            el.classList.remove('ss-activa');
          });
          p.classList.add('ss-activa');
          seleccion[opcion] = p.getAttribute('data-valor');
          actualizar();
        });
      });
    });
  }

  function initFaqAnalitica() {
    document.querySelectorAll('.ss-faq__item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        item.closest('[data-ss-stagger]');
      });
    });
  }

  function initHeroCarrusel() {
    document.querySelectorAll('[data-ss-hero-carrusel]').forEach(function (carrusel) {
      var slides = Array.from(carrusel.querySelectorAll('[data-ss-slide]'));
      if (slides.length < 2) return;

      var media = carrusel.closest('.ss-hero__media');
      var puntos = media ? Array.from(media.querySelectorAll('[data-ss-slide-punto]')) : [];
      var anterior = media ? media.querySelector('.ss-hero__carrusel-anterior') : null;
      var siguiente = media ? media.querySelector('.ss-hero__carrusel-siguiente') : null;
      var indice = 0;
      var temporizador;
      var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function mostrar(nuevoIndice) {
        slides[indice].classList.remove('ss-hero__slide--activa');
        if (puntos[indice]) puntos[indice].classList.remove('ss-hero__carrusel-punto--activo');
        indice = (nuevoIndice + slides.length) % slides.length;
        slides[indice].classList.add('ss-hero__slide--activa');
        if (puntos[indice]) puntos[indice].classList.add('ss-hero__carrusel-punto--activo');
      }

      function reiniciarAutoplay() {
        if (reducirMovimiento) return;
        window.clearInterval(temporizador);
        temporizador = window.setInterval(function () {
          mostrar(indice + 1);
        }, 5000);
      }

      if (siguiente) {
        siguiente.addEventListener('click', function () {
          mostrar(indice + 1);
          reiniciarAutoplay();
        });
      }
      if (anterior) {
        anterior.addEventListener('click', function () {
          mostrar(indice - 1);
          reiniciarAutoplay();
        });
      }
      puntos.forEach(function (punto, i) {
        punto.addEventListener('click', function () {
          mostrar(i);
          reiniciarAutoplay();
        });
      });

      reiniciarAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initResenas();
    initGaleriaProducto();
    initVariantes();
    initFaqAnalitica();
    initPreciosConvertidos();
    initHeroCarrusel();
  });
})();
